// src/pages/About.js
import React, { useEffect, useRef } from 'react';
import { useContent } from '../context/ContentContext';
import StorySection from '../components/about/StorySection';
import ValuesSection from '../components/about/ValuesSection';
import SustainabilitySection from '../components/about/SustainabilitySection';
import { fadeIn } from '../utils/gsapAnimations';
import SectionLoader from '../components/common/SectionLoader';

function About() {
  const pageRef = useRef(null);
  const { content, loading, error } = useContent();

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  if (loading) return <SectionLoader message="Loading about page..." />;
  if (error) return (
    <div className="text-center py-16 text-xl font-montserrat text-red-600 bg-white rounded-2xl shadow-xl max-w-4xl mx-auto m-8">
      {error}
    </div>
  );

  const aboutContent = content.about || {};

  return (
    <div ref={pageRef} className="bg-cream min-h-screen">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-primary/5 via-cream to-cream py-16 lg:py-24 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair-display font-semibold text-primary mb-6 tracking-tight">
            {aboutContent.title || 'About Us'}
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl font-montserrat text-secondary max-w-4xl mx-auto leading-relaxed">
            We exist to bring quality, care, and meaning into everything we do.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 space-y-16 lg:space-y-24">
        {/* Story Section – Card wrapper */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-12 border border-gray-100 hover:shadow-3xl transition-shadow duration-300">
          <StorySection content={aboutContent.story} />
        </div>

        {/* Values Section – Card wrapper */}
        <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-12 border border-gray-100 hover:shadow-3xl transition-shadow duration-300">
          <ValuesSection content={aboutContent.values} />
        </div>

        {/* Sustainability Section – Card wrapper */}
        {aboutContent.sustainability && (
          <div className="bg-gradient-to-br from-green-50/50 to-cream rounded-3xl shadow-2xl p-8 lg:p-12 border border-green-100/70 hover:shadow-3xl transition-all duration-300">
            <SustainabilitySection content={aboutContent.sustainability} />
          </div>
        )}
      </div>
    </div>
  );
}

export default About;